import type { Listing, ListingSpace } from '~/models'

type ListingSpacesProps = {
  listing: Listing
}

const RATE_TYPES: { [key: string]: string } = {
  sf_year: '/SF/Year',
  month: '/Month',
  year: '/Year',
  sf_month: '/SF/Month',
}

export default function ListingSpaces({ listing }: ListingSpacesProps) {
  if (!listing.suites || listing.suites.length < 2) {
    return null
  }
  const spaces = [...listing.suites].filter((s) => s.available)
  spaces.sort((a, b) => (a.unit || '').localeCompare(b.unit || ''))

  const renderSf = (space: ListingSpace) => {
    const min = space.min_available_sf
    const max = space.max_available_sf
    if (!min && !max) {
      return null
    } else if (min !== max) {
      return `${min?.toLocaleString()} SF - ${max?.toLocaleString()} SF`
    }
    return `${min?.toLocaleString()} SF`
  }

  const renderRate = (space: ListingSpace) => {
    const min = space.rate_min
    const max = space.rate_max
    const rateType =
      space.rate_type && typeof RATE_TYPES[space.rate_type] !== 'undefined'
        ? ` ${RATE_TYPES[space.rate_type]}`
        : ''
    if (!min && !max) {
      return null
    } else if (min !== max) {
      return `$${min?.toLocaleString()} - $${max?.toLocaleString()}${rateType}`
    }
    return `$${min?.toLocaleString()}${rateType}`
  }
  return (
    <table className="min-w-full divide-y divide-gray-200">
      <thead>
        <tr>
          <th className="pb-1 pl-3 pr-3 text-left font-semibold">Name</th>
          <th className="pb-1 pl-3 pr-3 text-left font-semibold">Rate</th>
          {spaces.some((s) => s.min_available_sf) && (
            <th className="pb-1 pl-3 pr-3 text-left font-semibold">
              Available SF
            </th>
          )}
          {spaces.some((s) => s.acres) && (
            <th className="pb-1 pl-3 pr-3 text-left font-semibold">Acres</th>
          )}
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 bg-white">
        {spaces.map((space, index) => {
          return (
            <tr key={index}>
              <td className="whitespace-nowrap px-3 py-2 font-medium">
                {space.unit}
              </td>
              <td className="whitespace-nowrap px-3 py-2 text-gray-500">
                {renderRate(space)}
              </td>
              {space.min_available_sf ? (
                <td className="whitespace-nowrap px-3 py-2 text-gray-500">
                  {renderSf(space)}
                </td>
              ) : spaces.some((s) => s.min_available_sf) ? (
                <td></td>
              ) : null}
              {space.acres ? (
                <td className="whitespace-nowrap px-3 py-2 text-gray-500">
                  {space.acres} ac
                </td>
              ) : spaces.some((s) => s.acres) ? (
                <td></td>
              ) : null}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
